/**
 * @module Auth.section
 *
 * All authentication-related pages used to gain access to the main app.
 */
import AuthSection from './Auth.layout';

export default AuthSection;
